import styled from 'styled-components'
import {
    belowContainer,
    svgStroke
} from 'utilities/styled'
import Link from 'components/link'
import { containerProps as integrationContainerProps } from 'pages/integrations/lists/integrations/integration/s'
import Paragraph from 'components/typography/paragraph'
import StatusLabelBase from 'pages/integrations/components/status/label'
import { ArrowRight } from 'styled-icons/feather'

export const Instance = styled(Link)`
    display: grid;
    grid-template-columns: 24px 1fr 1fr auto 24px;
    column-gap: 16px;
    place-items: center start;

    padding-block: 16px;

    &:where(:hover, :focus-visible) {
        text-decoration: none;
    }

    ${belowContainer(integrationContainerProps)`
        grid-template-rows: 1fr auto;
        grid-template-columns: 24px 1fr 24px;
        row-gap: 8px;
    `}
`

export const Meta = styled.div``

export const Name = styled(Paragraph).attrs({ className: 'compact' })`
    ${Instance}:where(:hover, :focus-visible) & {
        text-decoration: underline;
    }
`

export const StatusLabel = styled(StatusLabelBase)`
    ${belowContainer(integrationContainerProps)`
        grid-row: 2;
        grid-column: 1 / 3;
    `}
`

export const FakeButton = styled(Paragraph).attrs({ className: 'small constructive compact' })`
    ${Instance}:where(:hover, :focus-visible) & {
        text-decoration: underline;
    }

    ${belowContainer(integrationContainerProps)`
        display: none;
    `}
`

export const Arrow = styled(ArrowRight)`
    ${svgStroke()}

    transition: translate .1s ease-in-out;

    ${Instance}:where(:hover, :focus-visible) & {
        translate: 4px;
    }

    ${belowContainer(integrationContainerProps)`
        grid-row: 1;
        grid-column: 3;
    `}
`